import { UPDATE_AVAILABLE } from "../mutation-types";

const getDefaultState = () => ({
  updateAvailable: false
});

export default {
  state: getDefaultState(),
  mutations: {
    [UPDATE_AVAILABLE](state) {
      state.updateAvailable = true;
    }
  },
  actions: {
    updateAvailable({ commit }) {
      commit(UPDATE_AVAILABLE);
    }
  }
};
